import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';

import * as styles from './TextButton.css';

interface ITextButtonProps {
  children: React.ReactNode;
  onClick(): void;
}

export const TextButton: React.FC<ITextButtonProps> = ({ children, onClick }) => {
  const handleClick = useEventCallback(() => {
    onClick();
  });

  return (
    <button type="button" className={styles['button']} onClick={handleClick}>
      {children}
    </button>
  );
};
